import { PositionAndDimensionsType, PositionType } from 'data/types';
import { FootprintAreaLabelMetrics } from './footprint-area-label-layout-types';
import {
  formatFootprintDimensions,
  getRectangularFootprintDimensions
} from './footprint-rectangle-dimensions';

export const AREA_LABEL_FONT_SIZE = 14;
export const DIMENSIONS_LABEL_FONT_SIZE = 12;
export const AREA_BASELINE_OFFSET = 20;
export const DIMENSIONS_LINE_OFFSET = 14;

const ASCENT_RATIO = 0.75;
const DESCENT_RATIO = 0.25;
const AVERAGE_CHARACTER_WIDTH_RATIO = 0.55;

export function formatFootprintAreaLabel(area: number): string {
  return `${area.toLocaleString()} sq ft`;
}

export function getFootprintDimensionsLabel(
  points: PositionType[]
): string | null {
  if (points.length < 3) return null;
  const dimensions = getRectangularFootprintDimensions(points);
  return dimensions ? formatFootprintDimensions(dimensions) : null;
}

function estimateTextWidth(text: string, fontSize: number): number {
  return text.length * fontSize * AVERAGE_CHARACTER_WIDTH_RATIO;
}

export function measureFootprintAreaLabel(
  areaLabel: string,
  dimensionsLabel: string | null
): FootprintAreaLabelMetrics {
  const areaBaseline = -AREA_BASELINE_OFFSET;
  const top = areaBaseline - AREA_LABEL_FONT_SIZE * ASCENT_RATIO;
  const bottom =
    dimensionsLabel === null
      ? areaBaseline + AREA_LABEL_FONT_SIZE * DESCENT_RATIO
      : areaBaseline +
        DIMENSIONS_LINE_OFFSET +
        DIMENSIONS_LABEL_FONT_SIZE * DESCENT_RATIO;
  const width = Math.max(
    estimateTextWidth(areaLabel, AREA_LABEL_FONT_SIZE),
    dimensionsLabel === null
      ? 0
      : estimateTextWidth(dimensionsLabel, DIMENSIONS_LABEL_FONT_SIZE)
  );
  return { width, top, bottom };
}

export function footprintAreaLabelBox(
  anchor: PositionType,
  metrics: FootprintAreaLabelMetrics
): PositionAndDimensionsType {
  return {
    x: anchor.x - metrics.width / 2,
    y: anchor.y + metrics.top,
    width: metrics.width,
    height: metrics.bottom - metrics.top
  };
}
